import { render, staticRenderFns } from "./CoursewareStructuralElementDiscussion.vue?vue&type=template&id=6bf02f9a&"
import script from "./CoursewareStructuralElementDiscussion.vue?vue&type=script&lang=js&"
export * from "./CoursewareStructuralElementDiscussion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports